export enum Rules {
  required = 'required',
}

export const FIELDS_TO_OMIT = ['fb-texteditor-options-validators'];
